import type { ReactNode } from 'react'

type SocialName = 'instagram' | 'facebook' | 'tiktok' | 'pinterest' | 'twitter' | 'x'

const ICONS: Record<SocialName, ReactNode> = {
  instagram: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
      <circle cx="12" cy="12" r="3.75" />
      <circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  facebook: (
    <path d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v7h3v-7h2.4L16 12h-3v-1c0-.6.4-1 1-1Z" />
  ),
  tiktok: (
    <path d="M14.2 4v9.15a3.15 3.15 0 1 1-2.35-3.05M14.2 8.1c1.35 1.15 3.05 1.85 4.8 1.95" />
  ),
  pinterest: (
    <path d="M12 3.5a8.5 8.5 0 0 0-3.1 16.4c-.05-.66-.1-1.68.02-2.4l1.16-4.92s-.3-.59-.3-1.46c0-1.37.8-2.4 1.78-2.4.84 0 1.25.63 1.25 1.39 0 .85-.54 2.11-.82 3.29-.23.98.5 1.78 1.47 1.78 1.77 0 2.96-1.87 2.96-4.56 0-2.38-1.71-4.05-4.16-4.05-2.83 0-4.5 2.12-4.5 4.32 0 .86.33 1.78.74 2.28a.3.3 0 0 1 .07.29l-.28 1.13c-.04.18-.15.22-.34.13-1.27-.59-2.07-2.45-2.07-3.94 0-3.14 2.28-6.02 6.58-6.02 3.45 0 6.14 2.46 6.14 5.75 0 3.43-2.16 6.19-5.16 6.19-1.01 0-1.96-.52-2.28-1.14l-.62 2.36c-.22.86-.83 1.94-1.24 2.6A8.5 8.5 0 1 0 12 3.5Z" />
  ),
  twitter: (
    <path d="M13.68 10.47 20.7 2.4h-1.66l-6.1 7.01L8.06 2.4H2.4l7.36 10.72L2.4 21.6h1.66l6.44-7.4 5.14 7.4h5.66L13.68 10.47Zm-2.28 2.62-.75-1.07L4.66 3.64h2.56l4.8 6.86.75 1.07 6.24 8.92h-2.56l-5.05-7.22Z" />
  ),
  x: (
    <path d="M13.68 10.47 20.7 2.4h-1.66l-6.1 7.01L8.06 2.4H2.4l7.36 10.72L2.4 21.6h1.66l6.44-7.4 5.14 7.4h5.66L13.68 10.47Zm-2.28 2.62-.75-1.07L4.66 3.64h2.56l4.8 6.86.75 1.07 6.24 8.92h-2.56l-5.05-7.22Z" />
  ),
}

export default function SocialIcon({
  name,
  size = 16,
}: {
  name: SocialName
  size?: number
}) {
  const filled = name === 'twitter' || name === 'x' || name === 'pinterest' || name === 'facebook'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={filled ? undefined : '1.6'}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICONS[name]}
    </svg>
  )
}

export function socialIconName(label: string): SocialName {
  const key = label.trim().toLowerCase()
  if (key === 'instagram' || key === 'facebook' || key === 'tiktok' || key === 'pinterest' || key === 'twitter' || key === 'x') {
    return key
  }
  return 'instagram'
}
